import type { CodeableConcept, PlanDefinition, Resource } from "@medplum/fhirtypes";
import { PLAN_DEFINITION_KIND_URL, type PlanDefinitionKind } from "./constants";

export { PLAN_DEFINITION_KIND, PLAN_DEFINITION_KIND_URL, type PlanDefinitionKind } from "./constants";

/** The `type` coding stamped on every PlanDefinition we write. See constants. */
export function planDefinitionKind(kind: PlanDefinitionKind): CodeableConcept {
  return {
    coding: [{ system: PLAN_DEFINITION_KIND_URL, code: kind, display: kind }],
  };
}

/**
 * Read a stored PlanDefinition's kind, or undefined for a row carrying no
 * marker in the current system.
 *
 * Strict: only PLAN_DEFINITION_KIND_URL counts. The read-only ramps for the four
 * superseded spellings are gone — every environment was reseeded under ADR-0022.
 */
export function planDefinitionKindOf(resource: Resource): PlanDefinitionKind | undefined {
  const pd = resource as PlanDefinition;
  return pd.type?.coding?.find((c) => c.system === PLAN_DEFINITION_KIND_URL)?.code as PlanDefinitionKind | undefined;
}

/** The token search value: `system|code`, so an unsystemed coding cannot match. */
export function planDefinitionKindToken(kind: PlanDefinitionKind): string {
  return `${PLAN_DEFINITION_KIND_URL}|${kind}`;
}
